export interface IAccount {
  accountId: number;
  accountName: string;
  accountIsActive: boolean;
}

export class AccountModel implements IAccount {
  accountId: number;
  accountName: string;
  accountIsActive: boolean;

  constructor(data: IAccount) {
    this.accountId = data.accountId;
    this.accountName = data.accountName;
    this.accountIsActive = data.accountIsActive;
  }
}
